import graphql from 'babel-plugin-relay/macro';
import { ROUTE_MEMBERS } from 'constant/routes';
import compose from 'lodash.flowright';
import PropType from 'prop-types';
import { QueryRenderer } from 'react-relay';
import { generatePath, Redirect, withRouter } from 'react-router-dom';
import { hasElevatedRights } from 'utils/elevatedRights';
import { withGqlClient, withUser } from 'wrappers';

import LoadingState from '../loadingState';
import Settings from './settings';

const query = graphql`
  query settingsRootQuery($orgRowId: BigInt!) {
    organizationByRowId(rowId: $orgRowId) {
      rowId
      name
      avatar
      canUpdate
    }
  }
`;

export const Renderer = ({ error, props: data }) => {
  if (error) return <div>error!</div>;
  if (!data) return <LoadingState />;
  const { organizationByRowId } = data;
  return <Settings organization={organizationByRowId} />;
};

Renderer.propTypes = {
  error: PropType.object,
  props: PropType.object
};

Renderer.defaultProps = {
  error: undefined,
  props: undefined
};

export const SettingsRoot = props => {
  const { environment, selectedOrganization, match, user } = props;

  // There are some users that have unrealistic data so we need to account
  // for them to not crash the UI.
  if (!(selectedOrganization && selectedOrganization.rowId)) {
    return null;
  }

  const { rowId } = selectedOrganization;
  const orgId = match.params.orgId || rowId;

  // Only superusers and developers may access organization settings.
  if (!hasElevatedRights(user)) {
    return <Redirect to={generatePath(ROUTE_MEMBERS, { orgId })} />;
  }

  const variables = { orgRowId: orgId };

  const RendererWithRouter = withRouter(Renderer);

  return (
    <QueryRenderer
      environment={environment}
      query={query}
      render={RendererWithRouter}
      variables={variables}
    />
  );
};

SettingsRoot.propTypes = {
  environment: PropType.object.isRequired,
  match: PropType.object.isRequired,
  selectedOrganization: PropType.object,
  user: PropType.object
};

SettingsRoot.defaultProps = {
  selectedOrganization: null,
  user: null
};

export default compose(withUser, withGqlClient)(SettingsRoot);
